module.exports = __webpack_public_path__ + "img/mongodb.7e3c94a5.svg";